import PropTypes from 'prop-types';

export default {
  classes: PropTypes.shape({})
};
